import { HTMLAttributes } from "react";
import { cn } from "../../lib/utils.ts";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "linen" | "outline";
  padding?: "none" | "sm" | "md" | "lg";
}

export function Card({
  variant = "default",
  padding = "md",
  className,
  children,
  ...props
}: CardProps) {
  const variantStyles = {
    default: "bg-white border border-slate-200 shadow-sm",
    linen: "bg-heritage-linen border-none shadow-none",
    outline: "bg-transparent border border-heritage-linen shadow-none",
  };

  const paddingStyles = {
    none: "p-0",
    sm: "p-4",
    md: "p-8",
    lg: "p-12",
  };

  return (
    <div
      className={cn(
        "rounded-2xl transition-all",
        variantStyles[variant],
        paddingStyles[padding],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
